export enum SPLITIO_STATUS {
  on = 'on',
  off = 'off',
  control = 'control',
}
